import React from 'react'
import { createRoot } from 'react-dom/client'
import { keycloak } from './lib/authentication'
import { App } from './App'
import { logError } from './lib/logError'
import './styles/main.css'

const mountNode = document.getElementById('root')
if (!mountNode) {
  throw new Error('Could not get #root element')
}
const root = createRoot(mountNode!)

keycloak.init({ onLoad: 'login-required' }).then(
  () => {
    root.render(<App />)
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (err: any) => {
    if (err === 'Unauthenticated') {
      keycloak.login()
      return
    }
    if (err) {
      logError(new Error('Authentication failed'), err)
    } else {
      logError(new Error('Authentication failed'), new Error('Unknown error'))
    }

    root.render(<div className="alert alert-danger">Wooopsie, authentication failed for some reason!</div>)
  },
)
